/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getFromLocalStorage } from '../../components/helper/authorizationHelper';
import { postAsync } from '../../components/helper/axiosHelper';
const UserVerification = () => {

  const { id, value, isEmail } = useParams()

  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(false);
  const [epUserID, setEpUserID] = useState("");
  const [OTPVerify, setOTPVerify] = useState(false);
  const hasMounted = useRef(false);

  const token = localStorage.getItem('token');



  let axiosConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  };


  useEffect(() => {
    localStorage.setItem('isHome', false);
    const retrievedData = getFromLocalStorage("upid");
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    if (epUserID !== null) {
      handleUpdateData()
    }
  }, [epUserID]);


  // useEffect(() => {
  //   if (!hasMounted.current) {
  //     (async () => {
  //       setIsLoading(true)
  //       const emailBody = {
  //         userId: id,
  //         email: value,
  //         number: ""
  //       }
  //       const numberBody = {
  //         userId: id,
  //         email: "",
  //         mobile: value
  //       }
  //       const body = isEmail === "true" ? emailBody : numberBody
  //       await postAsync('EP_UserAuthentication/UpdateContactInfo', body, axiosConfig)
  //         .then((response) => {
  //           setIsLoading(true)
  //           if (response.statusCode === 200) {
  //             navigate('/user')
  //           }
  //           toast.success(response.message);
  //         })
  //         .catch((error) => {
  //           console.log(error.response.data.message, "errorerror")
  //           setIsLoading(false)
  //           toast.error(error.response.data.message);
  //         });
  //     })();
  //   }
  // }, []);




  // const handleSubmit = async (OTPNumber) => {
  //   setIsLoading(true)
  //   console.log(OTPNumber.length, "length")
  //   console.log("i am done ")
  //   const body = {
  //     otp: OTPNumber,
  //     isEmail: isEmail,
  //     email: isEmail ? updatedData.email : "",
  //     mobile: isEmail ? "" : updatedData.mobile,
  //     EPUserID: userId
  //   }

  //   console.log(body, "bodybody")
  //   await postAsync('EP_UserAuthentication/ConfirmUpdateOTP', body, axiosConfig)
  //     .then((response) => {
  //       console.log(response.data[0], "Asdasdasdasd")

  //       const link = `${baseURL}/verify/user/${response.data[0]}/${updatedData.email}`
  //       console.log(link, "linklink")
  //       toast.success(response.message);
  //       setOTPVerify(true)
  //       setIsLoading(false)

  //       setTimeout(() => {
  //         setOtpModal(false)
  //       }, 3000);
  //     })
  //     .catch((error) => {
  //       console.log(error)
  //       setIsLoading(false)
  //       toast.error(error.response.data.message);
  //     });
  // }

  const handleUpdateData = async () => {
    setIsLoading(true)
    const emailBody = {
      userId: epUserID,
      email: value
    }
    const numberBody = {
      userId: epUserID,
      mobile: value
    }
    const body = isEmail === "true" ? emailBody : numberBody
    await postAsync('EP_UserAuthentication/UpdateContactInfo', body, axiosConfig)
      .then((response) => {
        setIsLoading(true)
        if (response.statusCode === 200) {
          navigate('/user')
        }
        toast.success(response.message);
      })
      .catch((error) => {
        console.log(error.response.data.message, "errorerror")
        setIsLoading(false)
        toast.error(error.response.data.message);
      });
  }



  return (<></>);



};

export default UserVerification;
